import { getWebhookConfigDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const getWebhookConfigCallable = getCallable(getWebhookConfigDefinition);
